module.exports = __webpack_public_path__ + "static/media/threemenandamovie.bf85d312.wav";